import { useState, useCallback, useEffect } from "react"
import { client } from "@lib/api"
import * as Sentry from "@sentry/react"

const useFavoriteEWallet = () => {
    const [favorites, setFavorites] = useState<Set<string>>(new Set())

    useEffect(() => {
        client.doGet<{ uuid: string; is_favorite: boolean }[]>('/v2/wallet/ewallet-accounts')
            .then(list => {
                setFavorites(
                    new Set(list.filter(e => e.is_favorite).map(e => e.uuid))
                )
            })
            .catch(Sentry.captureException)
    }, [])

    const toggleFavorite = useCallback((uuid: string) => {
        setFavorites(prev => {
            const previous = new Set(prev)
            const next = new Set(prev)
            const newValue = !next.has(uuid)
            if (newValue) {
                next.add(uuid)
            } else {
                next.delete(uuid)
            }
            client.doPatch(`/v2/wallet/ewallet-account/${uuid}/favorite`, { is_favorite: newValue })
                .catch((err) => {
                    setFavorites(previous)
                    Sentry.captureException(err)
                })
            return next
        })
    }, [])

    const isFavorite = useCallback((uuid: string) => favorites.has(uuid), [favorites])

    return { isFavorite, toggleFavorite }
}

export default useFavoriteEWallet
